import React from "react";
import { Breakpoint } from "react-socks";

const hexToRgba = (hex, alpha) => {
    if (!hex) return `rgba(128,128,128,${alpha})`;

    let c = hex.replace("#", "");

    if (c.length === 3) {
        c = c.split("").map(x => x + x).join("");
    }

    const bigint = parseInt(c, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const CustomerZones = ({ zones }) => {
    if (!zones || zones.length === 0) return null;

    const renderCircle = (zone) => {
        const percent = zone.targetPoints
            ? Math.min(zone.points / zone.targetPoints, 1)
            : 0;

        const fillPercent = percent * 100;

        return (
            <div
                title={zone.toolTip}
                className="customer-zone-circle"
                style={{
                    // width: size,
                    // height: size,
                    // borderRadius: "50%",
                    // cursor: "pointer",

                    background: `linear-gradient(
                        to top,
                        ${zone.color || "gray"} ${fillPercent}%,
                        ${hexToRgba(zone.color || "#808080", 0.5)} ${fillPercent}%
                    )`,

                    // border: "2px solid white",
                    boxShadow: `0 0 6px ${zone.color || "gray"}`,
                    opacity: percent < 1 ? 0.7 : 1,
                    transition: "all 0.3s ease"
                }}
            />
        );
    };

    return (
        <div className="customer-zones-container">
            {zones.map((zone, index) => (
                <div key={index}>
                    <Breakpoint medium up>
                        {renderCircle(zone)}
                    </Breakpoint>
                    <Breakpoint small down>
                        {renderCircle(zone)}
                    </Breakpoint>
                </div>
            ))}
        </div>
    );
};

export default CustomerZones;